module.exports = __webpack_public_path__ + "img/tableContent-banner.2afc2158.png";